module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-desktop@3x-248ddd877ac25966ca2eab04f6a24d1b.jpg";